import { render } from "./ToolHeader.vue?vue&type=template&id=0a8eff86&scoped=true"
import script from "./ToolHeader.vue?vue&type=script&lang=js"
export * from "./ToolHeader.vue?vue&type=script&lang=js"

import "./ToolHeader.vue?vue&type=style&index=0&id=0a8eff86&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8eff86"]])

export default __exports__